import { useEffect, useState } from "react";

const mediaQuery = (query: string): MediaQueryList | undefined =>
    typeof window !== "undefined" && typeof window.matchMedia === "function"
        ? window.matchMedia(query)
        : undefined;

/** Whether the CSS media query holds, kept current as the window changes. */
export function useMediaQuery(query: string): boolean {
    const [matches, setMatches] = useState(() => mediaQuery(query)?.matches ?? false);

    useEffect(() => {
        const list = mediaQuery(query);
        if (!list) return;
        const update = () => setMatches(list.matches);
        update();
        list.addEventListener("change", update);
        return () => list.removeEventListener("change", update);
    }, [query]);

    return matches;
}
